import { DateService } from './../services/date.service';
import { DatePipe } from '@angular/common';
import { Component, Injectable, NgZone, OnInit } from '@angular/core';
import {
  NgbCalendar,
  NgbDate,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerConfig,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { DownloadFileService } from '../services/downloadfile.service';
import { AppStateProvider } from '../providers/app-state.provider';
import { Workbook } from 'exceljs';
import { ParkiteReportService } from '../services/parkite-report.service';


@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-parkite-reports',
  templateUrl: './parkite-reports.component.html',
  styleUrls: ['./parkite-reports.component.scss']
})
export class ParkiteReportsComponent implements OnInit {


  reportsList = [
    {
      index: '0',
      type: 'Frie Warden Report - Company',
    },
    {
      index: '1',
      type: 'VMS Report',
    },
    {
      index: '2',
      type: 'Events Report',
    }
  ];
  pageNo: number = 0;
  pageSize: number = 0;
  totalRows: number = 0;
  selectedIndex: number = 0;
  DownloadTypes: any = [{ id: '1', type: 'Download as PDF' }, { id: '2', type: 'Download as Excel' },];
  inviteTypes: any[] = [{ id: '', name: 'All' }]
  selectedInviteType: any;
  multiSelectionInvitationType: any = [];
  fDate: string;
  tDate: string;
  page: any;
  toDate: any;
  fromDate: any;
  formattedSelectedToDate: string = "";
  formattedSelectedDate: string = '';
  selectedDate: any;
  selectedToDate: string;
  searchText: string = '';
  selectedEventCat: any;
  selectedEventCatId:any;
  eventCategory: any[] = [{id: '{00000000-0000-0000-0000-000000000000}', name: 'All'}]
  isDesc: boolean = false;
  column: string = 'MeetingRoom';
  SelectedDownloadReportType: any = [];
  fireWardenList: any[] = []
  vmsList: any[] = []
  worksheet;
  workbook;
  PdfReportrows = [];
  reportsLoaded: boolean = false;
  invitationTypes: any;
  selectedInvitatoinTypeId: any;
  eventList: any[] = []

  constructor(
    public datepipe: DatePipe,
    private reportService: ParkiteReportService,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private downloadFileService: DownloadFileService
  ) {
    this.DownloadTypes = [
      { id: '1', type: 'Download as PDF' },
      { id: '2', type: 'Download as Excel' },
    ];
    ngbDatepickerConfig.minDate = {
      year: 1970, month: 1, day: 1
    };

    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    const jsDate = new Date();
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())

    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())

    this.fromDate = new Date(jsDate.toLocaleDateString('en-US'));
    this.toDate = new Date(jsDate.toLocaleDateString('en-US'));

    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();

    this.selectedIndex = 0;
    this.showReportData();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  selectedReportType(item) {
    this.selectedIndex = parseInt(item);
    this.showReportData();
  }
  getinvitationTypes() {
    this.reportsLoaded = false;

    this.reportService.getInvitationType().subscribe((r) => {
      this.invitationTypes = r.list;
      this.selectedInvitatoinTypeId = null;
      const allOpt = {
        invitationTypeId: null,
        invitationType: 'All',
      };
      this.invitationTypes.unshift(allOpt);

      if (this.selectedInvitatoinTypeId == null && this.invitationTypes.length > 0) {
        this.selectedInvitatoinTypeId = this.invitationTypes[0].invitationTypeId;
        this.selectInviteType(this.invitationTypes[0]);
      }
      this.reportsLoaded = true;
    });
  };
  selectInviteType(item) {
    if (item.invitationTypeId !== null)
      if (this.multiSelectionInvitationType.includes(item.invitationTypeId))
        this.multiSelectionInvitationType.splice(
          this.multiSelectionInvitationType.indexOf(item.invitationTypeId),
          1
        );
      else this.multiSelectionInvitationType.push(item.invitationTypeId);
    else this.multiSelectionInvitationType = [];

    let length = this.multiSelectionInvitationType.length - 1;
    this.selctionlength = length;
    this.selectedInvitatoinTypeId = item.invitationTypeId;

    if (item.invitationType != 'All') {
      this.selectedType = this.invitationTypes.find(
        (x) =>
          x.invitationTypeId ==
          this.multiSelectionInvitationType[
          this.multiSelectionInvitationType.length - 1
          ]
      ).invitationType;
    } else {
      this.selectedType = item.invitationType;
    }
    this.selectedInviteType = item.invitationType;
    this.getVMSReportData();
  }
  selectedType: any;
  selctionlength: number;
  showReportData() {
    switch (this.selectedIndex) {
      case 0:
        this.getFirewardenReportData();
        this.totalRows = this.fireWardenList?.length;
        break;
      case 1:
        this.getinvitationTypes();
        this.getVMSReportData();
        this.totalRows = this.vmsList?.length;
        break;
      case 2:
        if (this.selectedEventCatId == undefined)
        {
          this.selectedEventCatId = this.eventCategory[0].id;
          this.selectedEventCat = this.eventCategory[0].name;
        }
        this.getEventsCategory();
        this.getEventsReportData();
        break;
    }
  }

  getEventsCategory()
  {
    this.reportService.getEventsCategory().subscribe(
      (response: any) => {

        if (response.list != null)
        {
          response.list.forEach((e) => {
             let tempEC = {
                 id: e.id,
                 name: e.name
             };

              this.eventCategory.push(tempEC)

           });
        }
      },
      err => console.log('error', err)
    );
  }

  getEventsReportData()
  {
    const eventsReportRequestModel = {
      eventCategoryId: this.selectedEventCatId,
      eventFromDate: this.selectedDate,
      eventToDate: this.selectedToDate,
      eearchText:  this.searchText,
      pageNo: this.pageNo,
      size: this.pageSize
    };

    this.reportService.getEventsReportData(eventsReportRequestModel).subscribe(
      (response: any) => {
        console.log('s', response);
        //let data = JSON.parse(response)
        // this.processApiResponse(response);
          this.eventList = response.list;
      },
      err => console.log('error', err)
    );
  }


  getFirewardenReportData() {
    const fireWardenReportInputModel = {
      scanType: 1,
      TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: this.pageSize
    };

    this.reportService.getFireWardenReportData(fireWardenReportInputModel).subscribe(
      (response: any) => {
        console.log('s', response);
        this.fireWardenList = response.data;
      },
      err => console.log('error', err)
    );
  }

  getVMSReportData() {
    const VMSReportInputModel = {
      invitationType: this.selectedInviteType ??  "All" ,
      //invitationType: "individualInvite",
      TenantId: "b8657e8d-c137-46a4-9de0-bdbb01b8fc04", //  localStorage.getItem(AppConstant.localStorage.parkTenantId);
      fromDate: this.selectedDate,
      toDate: this.selectedToDate,
      searchTerm: this.searchText,
      pageNo: this.pageNo,
      size: this.pageSize
    };

    this.reportService.getVMSReportData(VMSReportInputModel).subscribe(
      (response: any) => {
        console.log('s', response);
        this.vmsList = response.data;
        this.reportsLoaded = true;
      },
      err => console.log('error', err)
    );
  }


  handlePageChangeMeeting(event) {
    this.page = event;
    console.log('pagination clicked');
    // this.meetingRoom = this.invitationTypes.map(
    //   (meeting: any, i: any) => ({ id: i + 1, ...meeting })).slice(
    //     (this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
    this.vmsList = this.vmsList.slice(
      0,
      this.vmsList.length < 10
        ? this.vmsList.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  public async updateSelectedDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    this.fromDate = jsDate;
    this.fDate = this.updateDateToCalendar(date);
    this.selectedDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year)
    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.showReportData();
      } else {
        this.zone.run(() => {
          this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
          this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())
        });
        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.resetDate(this.selectedIndex);
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  resetDate(id) {
    this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());

    this.selectedToDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear());

    this.fDate = this.updateDateToCalendar();
    this.tDate = this.updateDateToCalendar();
    localStorage.setItem('temp', id);
    window.location.reload();
  }

  updateDateToCalendar(date?: NgbDate) {
    const updatedDate =
      date == undefined
        ? this.dateAdapter.toModel(this.ngbCalendar.getToday())!
        : this.dateAdapter.toModel(date)!;
    return updatedDate;
  }

  public async updateSelectedToDate(date: NgbDate) {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.toDate = jsDate;
    this.tDate = this.updateDateToCalendar(date);
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(date.day, date.month - 1, date.year)

    if (this.fromDate && this.toDate) {
      if (this.fromDate <= this.toDate) {
        this.showReportData();
      } else {
        this.selectedDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy'); 2
        this.formattedSelectedDate = this.dateSrv.convertDateToLocaleString(new Date().getDate(), new Date().getMonth(), new Date().getFullYear())


        this.appStateSrv.showToast(
          'From date should not be greater than to date'
        );
        await delay(2000);
        this.resetDate(this.selectedIndex);
        // this.selectedReportType(this.selectedIndex)
      }
    } else {
      this.appStateSrv.showToast('Please select from and to date');
    }
  }

  selectEventCat(value) {
    this.selectedEventCat = value.name;
    this.selectedEventCatId = value.id;
    this.getEventsReportData();
  }

  sort(property, list) {
    console.log(property);
    this.isDesc = !this.isDesc; //change the direction
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    let sortedArray = list.sort(function (a, b) {
      if (a[property] < b[property]) {
        return -1 * direction;
      } else if (a[property] > b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });
    return sortedArray;
  }

  selectedReportDownload(item) {
    this.SelectedDownloadReportType = [];
    if (item.id !== null) {
      this.SelectedDownloadReportType.push(item.id);
    } else {
      this.SelectedDownloadReportType.push(1);
    }
    if (item.id == 2) {
      this.DownloadReport();
    } else if (item.id == 1) {
      this.DownloadReportPDF();
    }
  }

  DownloadReport() {
    this.worksheet = null;
    this.pageNo = 0;
    this.pageSize = 0;
    let reportname;
    if (this.selectedIndex == 0) {
      this.workbook = new Workbook();

      reportname = 'Fire Warden Report - Company';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'ERT Member name', key: 'ERTMembername', width: 10 },
        { header: 'Scanned Employee Name', key: 'ScannedEmployeeName', width: 10 },
        { header: 'Scan Date', key: 'ScanDate', width: 10 },
        { header: 'Scan Time', key: 'ScanTime', width: 10 },
        { header: 'Scanned Employee Email', key: 'ScannedEmployeeEmail', width: 10 },
        { header: 'Scanned Employee Mobile Number', key: 'ScannedEmployeeMobileNumber', width: 10 }
      ];

      let data;
      this.getFirewardenReportData();
      data = this.fireWardenList;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            ERTMembername: e.ertMbrName,
            ScannedEmployeeName: e.scannedEmployeeName,
            ScanDate: e.scannedDate,
            ScanTime: e.scannedTime,
            ScannedEmployeeEmail: e.scannedEmployeeEmail,
            ScannedEmployeeMobileNumber: e.mobileNumber
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);
    }
    else if (this.selectedIndex == 1) {
      this.workbook = new Workbook();

      reportname = 'VMS Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'System Record Id', key: 'SystemRecordId', width: 10 },
        { header: 'Visitor Company', key: 'VisitorCompany', width: 10 },
        { header: 'Visitor Name', key: 'VisitorName', width: 10 },
        { header: 'Visitor MobileNo', key: 'VisitorMobileNumber', width: 10 },
        { header: 'Visitor Email', key: 'VisitorEmail', width: 10 },
        { header: 'DateOfVisit', key: 'DateOfVisit', width: 10 },
        { header: 'Time of visit', key: 'TimeIn', width: 10 },
        { header: 'Host Name', key: 'HostName', width: 10 },
        { header: 'Host Mobile no', key: 'HostMobileno', width: 10 },
        { header: 'Host Email', key: 'HostEmail', width: 10 },
        { header: 'Park Name', key: 'ParkName', width: 10 },
        { header: 'Building', key: 'Building', width: 10 },
      ];

      let data;
      this.getVMSReportData();
      data = this.vmsList;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            SystemRecordId: e.systemRecordId,
            VisitorCompany: e.visitorCompany,
            VisitorName: e.visitorName,
            VisitorMobileNumber: e.visitorMobileNumber,
            VisitorEmail: e.visitorEmail,
            DateOfVisit: e.dateOfVisit,
            TimeIn: e.timeIn,
            HostName: e.hostName,
            HostMobileno: e.hostMobileno,
            HostEmail: e.hostEmail,
            ParkName: e.parkName,
            Building: e.building
          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);


    } else if (this.selectedIndex == 2) {
      this.workbook = new Workbook();

      reportname = 'Events Report';
      this.worksheet = this.workbook.addWorksheet(reportname);
      this.worksheet.columns = [
        { header: 'Sr.No', key: 'SrNo', width: 10 },
        { header: 'Event Category', key: 'EventCategory', width: 10 },
        { header: 'Event Title', key: 'EventTitle', width: 10 },
        { header: 'Start Date', key: 'StartDate', width: 10 },
        { header: 'End Date', key: 'EndDate', width: 10 },
        { header: 'Event Participation Type', key: 'EventParticipationType', width: 10 },
        { header: 'Team Name', key: 'TeamName', width: 10 },
        { header: 'Count of Participants', key: 'CountofParticipants', width: 10 },
        { header: 'Captain Name', key: 'CaptianName', width: 10 },
        { header: 'Captain Mobile no', key: 'CaptianMobileno', width: 10 },
        { header: 'Captain Email', key: 'CaptianEmail', width: 10 },
        { header: 'Participant Name(s)', key: 'ParticipantName(s)', width: 10 },
        { header: 'Attendance', key: 'Attendance', width: 10 },
        { header: 'Feedback', key: 'Feedback', width: 10 }
      ];

      let data;
      this.getEventsReportData();
      data = this.eventList;
      data.forEach((e) => {
        this.worksheet.addRow(
          {
            SrNo: e.srNo,
            EventCategory: e.eventCategory,
            EventTitle: e.eventTitle,
            StartDate: e.startDate,
            EndDate: e.endDate,
            EventParticipantType: e.eventParticipantType,
            TeamName: e.teamName,
            ParticipantsCount: e.participantsCount,
            CaptianName: e.captain.name,
            CaptianPhone: e.captain.phone,
            CaptianEmail: e.captain.email,
            Participants: e.participants,
            Attendance: e.attendance,
            Feedback: e.feedback

          },
          'n'
        );
      });
      this.downloadFileService.exportExcel(this.workbook, data, reportname);


    }
  }


  DownloadReportPDF() {
    this.PdfReportrows = [];
    if (this.selectedIndex == 0) {
      let head;

      head = [
        [
          'Sr.No',
          'ERT Member name',
          'Scanned Employee Name',
          'Scan Date',
          'Scan Time',
          'Scanned Employee Email',
          'Scanned Employee Mobile Number'
        ],
      ];
      this.getFirewardenReportData();
      this.fireWardenList.forEach((element) => {
        var temp = [
          element.srNo,
          element.ertMbrName,
          element.scannedEmployeeName,
          element.scannedDate,
          element.scannedTime,
          element.employeeEmail,
          element.mobileNumber
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(
        this.PdfReportrows,
        'VMS Report',
        head,
        'p'
      );

    }else if (this.selectedIndex == 2) {
      let head;

        head = [
          [
            'Sr.No',
            'Event Category',
            'Event Title',
            'Start Date',
            'End Date',
            'Event Participation Type',
            'Team Name',
            'Count of Participants',
            'Captain Name',
            'Captain Mobile no',
            'Captain Email',
            'Participant Name(s)',
            'Attendance',
            'Feedback'
          ],
        ];
        this.getFirewardenReportData();
        this.fireWardenList.forEach((element) => {
          var temp = [
            element.srNo,
            element.eventCategory,
            element.eventTitle,
            element.startDate,
            element.endDate,
            element.eventParticipantType,
            element.teamName,
            element.participantsCount,
            element.captain.name,
            element.captain.phone,
            element.captain.email,
            element.participants,
            element.attendance,
            element.feedback
          ];
          this.PdfReportrows.push(temp);
        });
        this.downloadFileService.openPDF(
          this.PdfReportrows,
          'Events Report',
          head,
          'p'
        );

    }
    else if (this.selectedIndex == 1) {
      let head;

      head = [
        [
          'Sr.No',
          'System Record Id',
          'Visitor Company',
          'Visitor Name',
          'Visitor MobileNo',
          'Visitor Email',
          'DateOfVisit',
          'Time of visit',
          'Host Name',
          'Host Mobile no',
          'Host Email',
          'Park Name',
          'Building'
        ],
      ];
      this.getVMSReportData;
      this.vmsList.forEach((e) => {
        var temp = [
          e.srNo,
          e.systemRecordId,
          e.visitorCompany,
          e.visitorName,
          e.visitorMobileNumber,
          e.visitorEmail,
          e.dateOfVisit,
          e.timeIn,
          e.hostName,
          e.hostMobileno,
          e.hostEmail,
          e.parkName,
          e.building
        ];
        this.PdfReportrows.push(temp);
      });
      this.downloadFileService.openPDF(
        this.PdfReportrows,
        'Fire Warden Report - Company',
        head,
        'p'
      );

    };

  }



}
